import { render, staticRenderFns } from "./bitrix.vue?vue&type=template&id=d4df3a70&"
import script from "./bitrix.vue?vue&type=script&lang=ts&"
export * from "./bitrix.vue?vue&type=script&lang=ts&"
import style0 from "./bitrix.vue?vue&type=style&index=0&id=d4df3a70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports